import { useUser } from "@dashboard/auth/useUser";
import useShop from "@dashboard/hooks/useShop";
import { useMemo } from "react";

import { getApiKeyPermissionChoices } from "../utils";

/** The store's permissions a key may hold, and the viewer's own. */
export const usePermissionChoices = () => {
  const shop = useShop();
  const { user } = useUser();
  const userPermissions = useMemo(() => user?.userPermissions ?? [], [user]);
  const choices = useMemo(
    () => getApiKeyPermissionChoices(shop?.permissions ?? [], userPermissions),
    [shop, userPermissions],
  );

  return { choices, userPermissions };
};
